const { getElement } = window.BAO.Utils

class ColumnSwitch extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.productGrid = getElement('[data-column-switch-external-el="product-grid"]')
    this.iconSecondColumn = getElement('[data-column-switch-el="second-column"]')
  }

  setupListeners () {
    super.setupListeners()

    this.handleClick = this.handleClick.bind(this)

    this.listeners.add(this, 'click', () =>
      this.handleClick(),
    )
  }

  handleClick () {
    const singleColumnGridClass = 'clc-Collection_GridItems-single'
    const singleColumnIconClass = 'clc-Collection_ColumnSwitchIconInner-hide'

    if (this.productGrid.classList.contains(singleColumnGridClass)) {
      // Switch to double column
      this.productGrid.classList.remove(singleColumnGridClass)
      this.iconSecondColumn.classList.remove(singleColumnIconClass)
      this.setCartAttribute('double')
    } else {
      // Switch to single column
      this.productGrid.classList.add(singleColumnGridClass)
      this.iconSecondColumn.classList.add(singleColumnIconClass)
      this.setCartAttribute('single')
    }

    // Create the custom event
    const switchEvent = new CustomEvent('clcSwitchActivated', {
      detail: {},
    })

    // Dispatch the custom event
    document.dispatchEvent(switchEvent)
  }

  setCartAttribute (column) {
    // eslint-disable-next-line compat/compat
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          current_column: column,
        },
      }),
    })
  }
}

if (!customElements.get('column-switch')) {
  customElements.define('column-switch', ColumnSwitch)
}
